import styled from "styled-components";
import formInputCommon from "./css/formInputCommon";
import buttonCommon from "./css/buttonCommon";

const FormInputButton = styled.button`
    ${formInputCommon}
    ${buttonCommon}
`;

export default FormInputButton;